export function generateUUID() {
  // rfc4122 version 4 compliant - http://stackoverflow.com/a/2117523/3594159
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}



/** WEBPACK FOOTER **
 ** ./src/utils/uuid/uuid.js
 **/